// @flow

import React, { type Node, useMemo } from 'react';
import { usePendingIncomingPayment, getSafeDueDate, getCountry } from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/voucher';
import { type Country } from '@tectonics/prs/country';
import { getWeekDay } from '@tectonics/prs/week-day';
import { Cell, Title, Value, ValueSmall, ValueSeparator } from './ticket';

export function VoucherTicketDueDate(): Node {
  return (
    <Cell>
      <Title>
        <TitleContent />
      </Title>

      <Value>
        <DueDateContent />
        <ValueSeparator />
        <ValueSmall>
          <DueDateWeekDay />
        </ValueSmall>
      </Value>
    </Cell>
  );
}

function TitleContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return 'Vencimento';

    case 'mx':
    case 'co':
    case 'pe':
    case 'ar':
    case 'bo':
      return 'Vencimiento';

    default:
      throw new Error(`Voucher Ticket Due Date Title - Not implemented for country "${country}" yet`);
  }
}

function DueDateContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
    case 'mx':
    case 'co':
    case 'pe':
    case 'ar':
    case 'bo':
      return formatDueDate(getSafeDueDate(incomingPayment));

    default:
      throw new Error(`Voucher Ticket Due Date Title - Not implemented for country "${country}" yet`);
  }
}

function DueDateWeekDay(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dueDate = getSafeDueDate(incomingPayment);

  const weekDays = useMemo(() => getWeekDays(country), [country]);
  const weekDay = useMemo(() => getWeekDay(dueDate, weekDays), [dueDate, weekDays]);

  return weekDay;
}

function getWeekDays(country: Country): ImmutableArray<string> {
  switch (country) {
    case 'br':
      return ['seg', 'seg', 'ter', 'qua', 'qui', 'sex', 'seg'];
    case 'mx':
    case 'co':
    case 'pe':
    case 'ar':
    case 'bo':
      return ['lun.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'lun.'];

    default:
      throw new Error(`Voucher Ticket - Not implemented yet week days list for "${country}"`);
  }
}
